<template>
    <div class="table-responsive">
        <table class="rate_schedule table table-hover border">
            <thead>
            <tr class="text-center">
                <th scope="col">&nbsp;</th>
                <th scope="col">Dates</th>
                <th scope="col">Extra Person Fee</th>
                <th scope="col">Minimum Nights</th>
                <th scope="col"> Rate/Night</th>
            </tr>
            </thead>
            <tbody>
            <tr class="text-center" v-for="rs in rate_schedule">
                <th scope="row" class="text-left">{{ rs.name }}</th>
                <td> {{ rs.from_date }} -
                    {{ rs.to_date }}
                </td>
                <td>{{ rs.extra_person }}</td>
                <td class="text-center">{{ rs.min_nights }}</td>
                <td>{{ rs.price }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

export default {
    name:       'App',
    components: {},
    data()
    {
        return {
            sku_id: null,
            state:  null,
            rate_schedule: []
        }
    },
    created()
    {
        this.sku_id = this.$parent.sku_id

        let server = window.location.hostname === 'localhost' ? 'http://localhost' : ''

        this.$http.get(server + "/ws/sku_rate_schedule", {
            params: {sku_id: this.sku_id}
        }).then(response =>
        {
            this.rate_schedule = response.data.rate_schedule
        }).catch(err =>
        {
            this.state = err
        })
    }
}
</script>

<style>
</style>
